import InventoryWidget from "../inventoryWidget/inventoryWidget";
import GoogleMaps from "../googleMaps/googleMaps";
import TpiElement from "../thirdPartyIntegrations/tpiElement";
import { queueForDeferral } from "./pagespeedOptimizer";
import CouponWidget from "../couponWidget/couponWidget";
import CouponWidgetSlim from "../couponWidget/couponWidgetSlim";
import DoCta from "../doCta/doCta";
import InputButtonPriceElement from "../inputButtonPriceElement/inputButtonPriceElement";
import PricingStack from "../pricingStack/pricingStack";
import PageScrollerElement from "../pageScroller/pageScrollerElement";
import PersonalizedOffer from "../personalizedOffer/personalizedOffer";

/**
 * A bundle for any core functionality that is (or could be) present on all pages.
 */
class Core {
  public constructor() {
    this.initialize();
  }

  private initialize() {
    const googleMaps = new GoogleMaps();
    const inventoryWidgets = new InventoryWidget();
    const tpiElement = new TpiElement();
    const couponWidget = new CouponWidget();
    const couponWidgetSlim = new CouponWidgetSlim();
    const doCtaController = new DoCta();
    const inputButtonPriceElementController = new InputButtonPriceElement();
    const pricingStackController = new PricingStack();
    const pageScrollerController = new PageScrollerElement();
    const personalizedOfferController = new PersonalizedOffer();

    queueForDeferral();
  }
}

DoUtility.SelfInstantiateOnLoad(Core);
